import { upgradeDelta, } from "../api/myClub/recommendations";
import { slotForRecommendation, } from "./squad";
/** The recommendation's own figures, for when the squad is not to hand. */
export const recFigures = (rec) => ({
    playerMeta: upgradeDelta(rec, "player-meta-upgrade"),
    playerChem: upgradeDelta(rec, "player-chemistry-upgrade"),
    squadMeta: upgradeDelta(rec, "team-meta-upgrade"),
    squadChem: upgradeDelta(rec, "team-chemistry-upgrade"),
});
/** A swap's figures, read off the squad with the swap worked out. */
export const swapFigures = (swapped) => {
    const slot = swapped.slots.find((s) => s.highlighted);
    if (!slot)
        return undefined;
    const { metaRating: after, previousMetaRating: before } = slot;
    return {
        playerMetaBefore: before,
        playerMetaAfter: after,
        playerChemBefore: slot.previousChemistry,
        playerChemAfter: slot.chemistry,
        playerMeta: after != null && before != null ? after - before : 0,
        playerChem: (slot.chemistry ?? 0) - (slot.previousChemistry ?? 0),
        squadMeta: (swapped.metaRating ?? 0) - (swapped.previousMetaRating ?? 0),
        squadChem: (swapped.chemistry ?? 0) - (swapped.previousChemistry ?? 0),
    };
};
/**
 * A recommendation as a swap on the active squad, or undefined when there is
 * no slot for it. The incoming card carries no meta ratings of its own, so
 * its rating in the slot is the slot's today plus the recommended rise; into
 * an empty position, the rise is the whole rating.
 */
export const swapForRecommendation = (rec, squad, toPitchPlayer) => {
    const slot = slotForRecommendation(squad, rec.oldPlayer);
    if (!slot || !rec.newPlayer)
        return undefined;
    const intoEmpty = !rec.oldPlayer?.resourceId;
    return {
        slotIndex: slot.index,
        inPlayer: toPitchPlayer(rec.newPlayer),
        inMetaRating: slot.metaRating != null || intoEmpty
            ? (slot.metaRating ?? 0) + upgradeDelta(rec, "player-meta-upgrade")
            : undefined,
        inMetaRatingZeroChem: rec.newPlayer.metaRatingZeroChem,
    };
};
/** A recommended card as a pitch player: it plays the position it is for. */
export const recPlayerOnPitch = (player) => ({
    ...player,
    preferredPosition: player.position,
});
export const REC_SORTS = [
    "squadMeta",
    "playerMeta",
    "squadChem",
    "playerChem",
    "price",
];
/** What taking the recommendation costs: coins, or the evolution's cost. */
export const recCost = (rec) => rec.type === "evolution"
    ? (rec.newPlayer?.evolutionCost ?? 0)
    : (rec.price ?? rec.newPlayer?.priceInfo?.displayPrice ?? 0);
/** Biggest gain first; cheapest first for price. */
const sortValue = {
    squadMeta: (_, f) => -f.squadMeta,
    playerMeta: (_, f) => -f.playerMeta,
    squadChem: (_, f) => -f.squadChem,
    playerChem: (_, f) => -f.playerChem,
    // A club player costs nothing.
    price: (rec) => (rec.type === "club" ? 0 : recCost(rec)),
};
/** The recommendations in `sort` order. Ties keep the backend's order. */
export const sortRecommendations = (recommendations, sort, figuresOf) => [...recommendations].sort((a, b) => sortValue[sort](a, figuresOf(a)) - sortValue[sort](b, figuresOf(b)));
//# sourceMappingURL=recommendations.js.map